export default __webpack_public_path__ + "static/media/y_wdt_c_0.06c43bc5.mp3";